import * as types from './mutation-types';

export default {
  [types.SET_TOGGLE_MODAL_EDIT_SERVICE](state) {
    state.modalEditServiceIsOpen = !state.modalEditServiceIsOpen;
  },
  [types.SET_SERVICE_TO_EDIT](state, payload) {
    state.serviceInEditing = payload;
  },
  [types.SET_TOGGLE_MODAL_CANCEL_NFSE](state) {
    state.modalCancelNfseIsOpen = !state.modalCancelNfseIsOpen;
  },
  [types.SET_TOGGLE_MODAL_FISCAL_VALIDATION](state) {
    state.modalFiscalValidationIsOpen = !state.modalFiscalValidationIsOpen;
  },
  [types.SET_MODAL_CANCEL_NFSE_ID](state, payload) {
    state.modalCancelNfseId = payload;
  },
};
